import React, {useEffect, useState} from 'react';
import {Autocomplete, Grid, TextField} from '@mui/material';
import {useTranslation} from 'react-i18next';
import ProfileAuth from './ProfileAuth';
import {Controller, useFormContext} from "react-hook-form";

const ProfileData = ({legalEntities, departments, profiles}: any) => {
    const {t} = useTranslation(['operator']);
    const {register, formState: {errors, defaultValues}, setValue, getValues, control} = useFormContext();
    const [filteredProfiles, setFilteredProfiles] = useState<any[]>(profiles);
    const [selectedAuths, setSelectedAuths] = useState<any[]>(getValues('auths')?.map((auth: any) => auth.name) || []);

    useEffect(() => {
        if (legalEntities.length === 1) {
            let tmpProfiles = profiles?.filter((profile: any) => {
                return legalEntities?.find((legalEntity: any) => legalEntity.id === profile.legalEntity.id);
            });
            setFilteredProfiles(tmpProfiles);
        } else {
            setFilteredProfiles(profiles);
        }
    }, [profiles]);

    useEffect(() => {
        setSelectedAuths(getValues('auths') || []);
    }, [defaultValues]);

    return (
        <>
            {legalEntities.length > 1 &&
                <Grid item xs={12} sm={3}>
                    <Controller
                        control={control}
                        name="legalEntity"
                        render={({field: {onChange, value}}: any) => (
                            <Autocomplete
                                onChange={(event, value) => {
                                    let tmpProfiles = profiles?.filter((profile: any) => {
                                        if (value?.length > 0) {
                                            return value?.find((legalEntity: any) => legalEntity.id === profile.legalEntity.id);
                                        } else {
                                            return null;
                                        }
                                    });
                                    setFilteredProfiles(tmpProfiles);
                                    onChange(value);
                                }}
                                value={value || null}
                                options={legalEntities}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                getOptionLabel={(option: any) => t('translation:legalEntities.'.concat(option.name))}
                                renderInput={(params) => (
                                    <TextField {...params}
                                               label={t("label.legalEntity")}
                                               error={Boolean(errors.legalEntities)}
                                               helperText={t(errors.legalEntities?.message as string)}
                                    />
                                )}
                            />
                        )}
                    />
                </Grid>
            }
            <Grid item xs={12} sm={3}>
                <Controller
                    control={control}
                    name="department"
                    render={({field: {onChange, value}}: any) => (
                        <Autocomplete
                            onChange={(event, value) => {
                                let tmpProfiles = profiles?.filter((profile: any) => {
                                    if (value?.length > 0) {
                                        return value?.find((department: any) => department.id === profile.department?.id);
                                    } else {
                                        return profile;
                                    }
                                });
                                setFilteredProfiles(tmpProfiles);
                                onChange(value);
                            }}
                            value={value || null}
                            options={departments}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            getOptionLabel={(option: any) => t('translation:departments.'.concat(option.name))}
                            renderInput={(params) => (
                                <TextField {...params}
                                           label={t("label.department")}
                                           error={Boolean(errors.departments)}
                                           helperText={t(errors.departments?.message as string)}
                                />
                            )}
                        />
                    )}
                />
            </Grid>
            <Grid item xs={12} sm={3}>
                <Controller
                    control={control}
                    name="name"
                    render={({field}: any) => (
                        <TextField
                            {...field}
                            fullWidth
                            type="text"
                            label={t('label.name')}
                            error={Boolean(errors.name)}
                            helperText={t(errors.name?.message as string)}
                            value={field.value || ''}
                        />
                    )}
                />
            </Grid>
            <Grid item xs={12} sm={3}>
                <Autocomplete
                    id={'profiles'}
                    options={filteredProfiles}
                    disableCloseOnSelect={true}
                    blurOnSelect={false}
                    getOptionLabel={(option: any) => option.name}
                    renderInput={(params) => (
                        <TextField {...params} label={t("label.copyProfile")}
                                   error={Boolean(errors.profiles)}
                                   helperText={t(errors.profiles?.message as string)}
                        />
                    )}
                    onChange={(event, value) => {
                        setValue('auths', value.auths);
                        setSelectedAuths(value.auths);
                    }}
                />
            </Grid>
            <Grid item sm={12}/>
            <ProfileAuth selectedAuths={selectedAuths} setSelectedAuths={setSelectedAuths} setValue={setValue}
                         getValues={getValues}/>
        </>
    );
};

export default ProfileData;
